module.exports = __webpack_public_path__ + "img/visitor-img2.84ae1b08.png";